/* =====================================================================
 * IsoCube — cubo decorativo (stesso markup di public/cube.svg) inline
 * così non dipende dal fetch dell’asset e gli id gradiente sono unici
 * per istanza (`uid`).
 * ===================================================================== */

interface IsoCubeProps {
  className?: string;
  uid?: string;
}

export default function IsoCube({ className, uid = 'iso' }: IsoCubeProps) {
  const g5 = `${uid}-cube-g5`;
  const g6 = `${uid}-cube-g6`;
  const g52 = `${uid}-cube-g52`;
  const g62 = `${uid}-cube-g62`;
  const g53 = `${uid}-cube-g53`;
  const g63 = `${uid}-cube-g63`;

  return (
    <svg
      className={className}
      viewBox="0 0 269.56 254.23"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient
          id={g5}
          x1="5189.59"
          y1="5048.01"
          x2="5409.88"
          y2="5048.01"
          gradientTransform="translate(-7177.1796 1199.9475) rotate(-52.13)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#dcb06c" />
          <stop offset=".1" stopColor="#c5a28a" />
          <stop offset=".3" stopColor="#8b81b8" />
          <stop offset=".34" stopColor="#7d7ab5" />
          <stop offset=".64" stopColor="#cca683" />
          <stop offset=".7" stopColor="#cd9777" />
          <stop offset=".81" stopColor="#d87861" />
          <stop offset=".84" stopColor="#db6d58" />
          <stop offset=".99" stopColor="#dc9381" />
        </linearGradient>
        <linearGradient
          id={g6}
          x1="1340.1"
          y1="9300.43"
          x2="1472.46"
          y2="9300.43"
          gradientTransform="translate(-4343.6057 8426.1672) rotate(-143.48)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#dcb06c" />
          <stop offset=".05" stopColor="#dcb06c" />
          <stop offset=".16" stopColor="#7d7ab5" />
          <stop offset=".29" stopColor="#db6d58" />
          <stop offset=".39" stopColor="#db6d58" />
          <stop offset=".53" stopColor="#dcb06c" />
          <stop offset=".71" stopColor="#db6d58" />
          <stop offset=".84" stopColor="#dc9381" />
          <stop offset=".9" stopColor="#6862a6" />
          <stop offset=".99" stopColor="#dc9381" />
        </linearGradient>
        <linearGradient
          id={g52}
          x1="4662.02"
          y1="2126.25"
          x2="4530.43"
          y2="2212.43"
          gradientTransform="translate(-4883.2449 -356.7366) rotate(-20.25)"
          xlinkHref={`#${g5}`}
        />
        <linearGradient
          id={g62}
          x1="1205.47"
          y1="9393.02"
          x2="1448.67"
          y2="9393.02"
          xlinkHref={`#${g6}`}
        />
        <linearGradient
          id={g53}
          x1="4204"
          y1="2215.23"
          x2="4075.52"
          y2="2213.01"
          gradientTransform="translate(-4529.8086 -106.0232) rotate(-24.47)"
          xlinkHref={`#${g5}`}
        />
        <linearGradient
          id={g63}
          x1="1206"
          y1="9284.18"
          x2="1367.71"
          y2="9284.18"
          xlinkHref={`#${g6}`}
        />
      </defs>
      <g style={{ isolation: 'isolate' }}>
        <path
          fill={`url(#${g5})`}
          stroke={`url(#${g6})`}
          strokeMiterlimit={10}
          strokeWidth={1.09}
          d="M8.87,76.52L93.8,1.04l28.46,141.94L26.69,227.91,1.03,99.92c-1.73-8.64,1.25-17.55,7.84-23.41h0Z"
        />
        <path
          fill={`url(#${g52})`}
          stroke={`url(#${g62})`}
          strokeMiterlimit={10}
          strokeWidth={1.09}
          d="M93.8,1.04l130.78,24.85c9.26,1.77,16.53,8.96,18.38,18.2l25.39,126.65-146.11-27.77L93.8,1.04Z"
        />
        <path
          fill={`url(#${g53})`}
          stroke={`url(#${g63})`}
          strokeMiterlimit={10}
          strokeWidth={1.09}
          d="M122.27,142.98l146.1,27.77-85.69,76.15c-6.23,5.54-14.67,7.86-22.85,6.32l-133.13-25.29,95.57-84.93v-.02h0Z"
        />
      </g>
    </svg>
  );
}
